import { useEffect, useRef } from 'react'

import { useAppSelector } from '@App/hooks'

export const useOnSuccessfulTrade = (callback: (taskIds: string[]) => void) => {
  const queueTasks = useAppSelector((root) => root.queueTasks.queueTasks)

  const handledTaskIdsRef = useRef<Set<string>>(new Set())

  useEffect(() => {
    const newSuccessfulTasks = queueTasks.filter(
      (task) =>
        task.status === 'success' &&
        (task.type === 'spot' || task.type === 'margin') &&
        !handledTaskIdsRef.current.has(task.id),
    )

    if (newSuccessfulTasks.length === 0) return

    callback(newSuccessfulTasks.map((t) => t.id))

    newSuccessfulTasks.forEach((task) => handledTaskIdsRef.current.add(task.id))
  }, [queueTasks, callback])
}
